// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2714.001%27 height=%278.165%27 viewBox=%270 0 14.001 8.165%27%3E%3Cdefs%3E%3Cstyle%3E.a%7Bfill:%23212121;%7D%3C/style%3E%3C/defs%3E%3Cpath class=%27a%27 d=%27M13.861,60.224l-.7-.7a.441.441,0,0,0-.645,0L7,65.036,1.487,59.522a.441.441,0,0,0-.645,0l-.7.7a.441.441,0,0,0,0,.645l6.537,6.538a.441.441,0,0,0,.645,0l6.538-6.538a.442.442,0,0,0,0-.645Z%27 transform=%27translate%280 -59.382%29%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23dc3545%27 viewBox=%27-2 -2 7 7%27%3e%3cpath stroke=%27%23dc3545%27 d=%27M0 0l3 3m0-3L0 3%27/%3e%3ccircle r=%27.5%27/%3e%3ccircle cx=%273%27 r=%27.5%27/%3e%3ccircle cy=%273%27 r=%27.5%27/%3e%3ccircle cx=%273%27 cy=%273%27 r=%27.5%27/%3e%3c/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "utf-8";
/* CSS Document */

:root {
  --main-color: #e1251b;
  --black: #000;
  --dark: #071822;
  --grey-regular: #f0f1f7;
  --white-color: #fff;
  --textclr1: #071822;
}

.mclr {
  color: var(--main-color);
}
.wclr {
  color: var(--white-color);
}

.width100per {
  width: 100%;
}
.height100per {
  height: 100%;
}
.width90per {
  width: 90%;
}
.width80per {
  width: 80%;
}
.width70per {
  width: 70%;
}
.width60per {
  width: 60%;
}
.width50per {
  width: 50%;
}
.width40per {
  width: 40%;
}
.width30per {
  width: 30%;
}
.width20per {
  width: 30%;
}
.width10per {
  width: 10%;
}

.border-radius20 {
  border-radius: 20px;
}

.cursor-pointer {
  cursor: pointer;
}
.mrgtop-0 {
  margin-top: 0px;
}
.mrgtop-5 {
  margin-top: 5px;
}
.mrgtop-10 {
  margin-top: 10px;
}
.mrgtop-15 {
  margin-top: 15px;
}
.mrgtop-20 {
  margin-top: 20px;
}
.mrgtop-25 {
  margin-top: 25px;
}
.mrgtop-30 {
  margin-top: 30px;
}
.mrgtop-35 {
  margin-top: 35px;
}
.mrgtop-40 {
  margin-top: 40px;
}
.mrgtop-45 {
  margin-top: 45px;
}
.mrgtop-50 {
  margin-top: 50px;
}
.mrgtop-55 {
  margin-top: 55px;
}
.mrgtop-60 {
  margin-top: 60px;
}
.mrgtop-65 {
  margin-top: 65px;
}
.mrgtop-70 {
  margin-top: 70px;
}
.mrgtop-75 {
  margin-top: 75px;
}
.mrgtop-80 {
  margin-top: 80px;
}
.mrgtop-85 {
  margin-top: 85px;
}
.mrgtop-90 {
  margin-top: 90px;
}
.mrgtop-95 {
  margin-top: 95px;
}
.mrgtop-100 {
  margin-top: 100px;
}
.mrgtop-105 {
  margin-top: 105px;
}
.mrgtop-110 {
  margin-top: 110px;
}
.mrgtop-115 {
  margin-top: 115px;
}
.mrgtop-120 {
  margin-top: 120px;
}
.mrgtop-125 {
  margin-top: 125px;
}
.mrgtop-130 {
  margin-top: 130px;
}
.mrgtop-135 {
  margin-top: 135px;
}
.mrgtop-140 {
  margin-top: 140px;
}
.mrgtop-145 {
  margin-top: 145px;
}
.mrgtop-150 {
  margin-top: 150px;
}
.mrgtop-155 {
  margin-top: 155px;
}
.mrgtop-160 {
  margin-top: 160px;
}
.mrgtop-165 {
  margin-top: 165px;
}
.mrgtop-170 {
  margin-top: 170px;
}
.mrgtop-175 {
  margin-top: 175px;
}
.mrgtop-180 {
  margin-top: 180px;
}
.mrgtop-185 {
  margin-top: 185px;
}
.mrgtop-190 {
  margin-top: 190px;
}
.mrgtop-195 {
  margin-top: 195px;
}
.mrgtop-200 {
  margin-top: 200px;
}

.mrgbtm-0 {
  margin-bottom: 0px;
}
.mrgbtm-5 {
  margin-bottom: 5px;
}
.mrgbtm-10 {
  margin-bottom: 10px;
}
.mrgbtm-15 {
  margin-bottom: 15px;
}
.mrgbtm-20 {
  margin-bottom: 20px;
}
.mrgbtm-25 {
  margin-bottom: 25px;
}
.mrgbtm-30 {
  margin-bottom: 30px;
}
.mrgbtm-35 {
  margin-bottom: 35px;
}
.mrgbtm-40 {
  margin-bottom: 40px;
}
.mrgbtm-45 {
  margin-bottom: 45px;
}
.mrgbtm-50 {
  margin-bottom: 50px;
}
.mrgbtm-55 {
  margin-bottom: 55px;
}
.mrgbtm-60 {
  margin-bottom: 60px;
}
.mrgbtm-65 {
  margin-bottom: 65px;
}
.mrgbtm-70 {
  margin-bottom: 70px;
}
.mrgbtm-75 {
  margin-bottom: 75px;
}
.mrgbtm-80 {
  margin-bottom: 80px;
}
.mrgbtm-85 {
  margin-bottom: 85px;
}
.mrgbtm-90 {
  margin-bottom: 90px;
}
.mrgbtm-95 {
  margin-bottom: 95px;
}
.mrgbtm-100 {
  margin-bottom: 100px;
}
.mrgbtm-105 {
  margin-bottom: 105px;
}
.mrgbtm-110 {
  margin-bottom: 110px;
}
.mrgbtm-115 {
  margin-bottom: 115px;
}
.mrgbtm-120 {
  margin-bottom: 120px;
}
.mrgbtm-125 {
  margin-bottom: 125px;
}
.mrgbtm-130 {
  margin-bottom: 130px;
}
.mrgbtm-135 {
  margin-bottom: 135px;
}
.mrgbtm-140 {
  margin-bottom: 140px;
}
.mrgbtm-145 {
  margin-bottom: 145px;
}
.mrgbtm-150 {
  margin-bottom: 150px;
}
.mrgbtm-155 {
  margin-bottom: 155px;
}
.mrgbtm-160 {
  margin-bottom: 160px;
}
.mrgbtm-165 {
  margin-bottom: 165px;
}
.mrgbtm-170 {
  margin-bottom: 170px;
}
.mrgbtm-175 {
  margin-bottom: 175px;
}
.mrgbtm-180 {
  margin-bottom: 180px;
}
.mrgbtm-185 {
  margin-bottom: 185px;
}
.mrgbtm-190 {
  margin-bottom: 190px;
}
.mrgbtm-195 {
  margin-bottom: 195px;
}
.mrgbtm-200 {
  margin-bottom: 200px;
}

.mrgrt-0 {
  margin-right: 0px;
}
.mrgrt-5 {
  margin-right: 5px;
}
.mrgrt-10 {
  margin-right: 10px;
}
.mrgrt-15 {
  margin-right: 15px;
}
.mrgrt-20 {
  margin-right: 20px;
}
.mrgrt-25 {
  margin-right: 25px;
}
.mrgrt-30 {
  margin-right: 30px;
}
.mrgrt-35 {
  margin-right: 35px;
}
.mrgrt-40 {
  margin-right: 40px;
}
.mrgrt-45 {
  margin-right: 45px;
}
.mrgrt-50 {
  margin-right: 50px;
}
.mrgrt-55 {
  margin-right: 55px;
}
.mrgrt-60 {
  margin-right: 60px;
}
.mrgrt-65 {
  margin-right: 65px;
}
.mrgrt-70 {
  margin-right: 70px;
}
.mrgrt-75 {
  margin-right: 75px;
}
.mrgrt-80 {
  margin-right: 80px;
}
.mrgrt-85 {
  margin-right: 85px;
}
.mrgrt-90 {
  margin-right: 90px;
}
.mrgrt-95 {
  margin-right: 95px;
}
.mrgrt-100 {
  margin-right: 100px;
}
.mrgrt-105 {
  margin-right: 105px;
}
.mrgrt-110 {
  margin-right: 110px;
}
.mrgrt-115 {
  margin-right: 115px;
}
.mrgrt-120 {
  margin-right: 120px;
}
.mrgrt-125 {
  margin-right: 125px;
}
.mrgrt-130 {
  margin-right: 130px;
}
.mrgrt-135 {
  margin-right: 135px;
}
.mrgrt-140 {
  margin-right: 140px;
}
.mrgrt-145 {
  margin-right: 145px;
}
.mrgrt-150 {
  margin-right: 150px;
}
.mrgrt-155 {
  margin-right: 155px;
}
.mrgrt-160 {
  margin-right: 160px;
}
.mrgrt-165 {
  margin-right: 165px;
}
.mrgrt-170 {
  margin-right: 170px;
}
.mrgrt-175 {
  margin-right: 175px;
}
.mrgrt-180 {
  margin-right: 180px;
}
.mrgrt-185 {
  margin-right: 185px;
}
.mrgrt-190 {
  margin-right: 190px;
}
.mrgrt-195 {
  margin-right: 195px;
}
.mrgrt-200 {
  margin-right: 200px;
}

.mrgleft-0 {
  margin-left: 0px;
}
.mrgleft-5 {
  margin-left: 5px;
}
.mrgleft-10 {
  margin-left: 10px;
}
.mrgleft-15 {
  margin-left: 15px;
}
.mrgleft-20 {
  margin-left: 20px;
}
.mrgleft-25 {
  margin-left: 25px;
}
.mrgleft-30 {
  margin-left: 30px;
}
.mrgleft-35 {
  margin-left: 35px;
}
.mrgleft-40 {
  margin-left: 40px;
}
.mrgleft-45 {
  margin-left: 45px;
}
.mrgleft-50 {
  margin-left: 50px;
}
.mrgleft-55 {
  margin-left: 55px;
}
.mrgleft-60 {
  margin-left: 60px;
}
.mrgleft-65 {
  margin-left: 65px;
}
.mrgleft-70 {
  margin-left: 70px;
}
.mrgleft-75 {
  margin-left: 75px;
}
.mrgleft-80 {
  margin-left: 80px;
}
.mrgleft-85 {
  margin-left: 85px;
}
.mrgleft-90 {
  margin-left: 90px;
}
.mrgleft-95 {
  margin-left: 95px;
}
.mrgleft-100 {
  margin-left: 100px;
}
.mrgleft-105 {
  margin-left: 105px;
}
.mrgleft-110 {
  margin-left: 110px;
}
.mrgleft-115 {
  margin-left: 115px;
}
.mrgleft-120 {
  margin-left: 120px;
}
.mrgleft-125 {
  margin-left: 125px;
}
.mrgleft-130 {
  margin-left: 130px;
}
.mrgleft-135 {
  margin-left: 135px;
}
.mrgleft-140 {
  margin-left: 140px;
}
.mrgleft-145 {
  margin-left: 145px;
}
.mrgleft-150 {
  margin-left: 150px;
}
.mrgleft-155 {
  margin-left: 155px;
}
.mrgleft-160 {
  margin-left: 160px;
}
.mrgleft-165 {
  margin-left: 165px;
}
.mrgleft-170 {
  margin-left: 170px;
}
.mrgleft-175 {
  margin-left: 175px;
}
.mrgleft-180 {
  margin-left: 180px;
}
.mrgleft-185 {
  margin-left: 185px;
}
.mrgleft-190 {
  margin-left: 190px;
}
.mrgleft-195 {
  margin-left: 195px;
}
.mrgleft-200 {
  margin-left: 200px;
}

/************** paddings ******************/
.padtop-0 {
  padding-top: 0px;
}
.padtop-5 {
  padding-top: 5px;
}
.padtop-10 {
  padding-top: 10px;
}
.padtop-15 {
  padding-top: 15px;
}
.padtop-20 {
  padding-top: 20px;
}
.padtop-25 {
  padding-top: 25px;
}
.padtop-30 {
  padding-top: 30px;
}
.padtop-35 {
  padding-top: 35px;
}
.padtop-40 {
  padding-top: 40px;
}
.padtop-45 {
  padding-top: 45px;
}
.padtop-50 {
  padding-top: 50px;
}
.padtop-55 {
  padding-top: 55px;
}
.padtop-60 {
  padding-top: 60px;
}
.padtop-65 {
  padding-top: 65px;
}
.padtop-70 {
  padding-top: 70px;
}
.padtop-75 {
  padding-top: 75px;
}
.padtop-80 {
  padding-top: 80px;
}
.padtop-85 {
  padding-top: 85px;
}
.padtop-90 {
  padding-top: 90px;
}
.padtop-95 {
  padding-top: 95px;
}
.padtop-100 {
  padding-top: 100px;
}
.padtop-105 {
  padding-top: 105px;
}
.padtop-110 {
  padding-top: 110px;
}
.padtop-115 {
  padding-top: 115px;
}
.padtop-120 {
  padding-top: 120px;
}
.padtop-125 {
  padding-top: 125px;
}
.padtop-130 {
  padding-top: 130px;
}
.padtop-135 {
  padding-top: 135px;
}
.padtop-140 {
  padding-top: 140px;
}
.padtop-145 {
  padding-top: 145px;
}
.padtop-150 {
  padding-top: 150px;
}
.padtop-155 {
  padding-top: 155px;
}
.padtop-160 {
  padding-top: 160px;
}
.padtop-165 {
  padding-top: 165px;
}
.padtop-170 {
  padding-top: 170px;
}
.padtop-175 {
  padding-top: 175px;
}
.padtop-180 {
  padding-top: 180px;
}
.padtop-185 {
  padding-top: 185px;
}
.padtop-190 {
  padding-top: 190px;
}
.padtop-195 {
  padding-top: 195px;
}
.padtop-200 {
  padding-top: 200px;
}

.padbtm-0 {
  padding-bottom: 0px;
}
.padbtm-5 {
  padding-bottom: 5px;
}
.padbtm-10 {
  padding-bottom: 10px;
}
.padbtm-15 {
  padding-bottom: 15px;
}
.padbtm-20 {
  padding-bottom: 20px;
}
.padbtm-25 {
  padding-bottom: 25px;
}
.padbtm-30 {
  padding-bottom: 30px;
}
.padbtm-35 {
  padding-bottom: 35px;
}
.padbtm-40 {
  padding-bottom: 40px;
}
.padbtm-45 {
  padding-bottom: 45px;
}
.padbtm-50 {
  padding-bottom: 50px;
}
.padbtm-55 {
  padding-bottom: 55px;
}
.padbtm-60 {
  padding-bottom: 60px;
}
.padbtm-65 {
  padding-bottom: 65px;
}
.padbtm-70 {
  padding-bottom: 70px;
}
.padbtm-75 {
  padding-bottom: 75px;
}
.padbtm-80 {
  padding-bottom: 80px;
}
.padbtm-85 {
  padding-bottom: 85px;
}
.padbtm-90 {
  padding-bottom: 90px;
}
.padbtm-95 {
  padding-bottom: 95px;
}
.padbtm-100 {
  padding-bottom: 100px;
}
.padbtm-105 {
  padding-bottom: 105px;
}
.padbtm-110 {
  padding-bottom: 110px;
}
.padbtm-115 {
  padding-bottom: 115px;
}
.padbtm-120 {
  padding-bottom: 120px;
}
.padbtm-125 {
  padding-bottom: 125px;
}
.padbtm-130 {
  padding-bottom: 130px;
}
.padbtm-135 {
  padding-bottom: 135px;
}
.padbtm-140 {
  padding-bottom: 140px;
}
.padbtm-145 {
  padding-bottom: 145px;
}
.padbtm-150 {
  padding-bottom: 150px;
}
.padbtm-155 {
  padding-bottom: 155px;
}
.padbtm-160 {
  padding-bottom: 160px;
}
.padbtm-165 {
  padding-bottom: 165px;
}
.padbtm-170 {
  padding-bottom: 170px;
}
.padbtm-175 {
  padding-bottom: 175px;
}
.padbtm-180 {
  padding-bottom: 180px;
}
.padbtm-185 {
  padding-bottom: 185px;
}
.padbtm-190 {
  padding-bottom: 190px;
}
.padbtm-195 {
  padding-bottom: 195px;
}
.padbtm-200 {
  padding-bottom: 200px;
}

.padrt-0 {
  padding-right: 0px;
}
.padrt-5 {
  padding-right: 5px;
}
.padrt-10 {
  padding-right: 10px;
}
.padrt-15 {
  padding-right: 15px;
}
.padrt-20 {
  padding-right: 20px;
}
.padrt-25 {
  padding-right: 25px;
}
.padrt-30 {
  padding-right: 30px;
}
.padrt-35 {
  padding-right: 35px;
}
.padrt-40 {
  padding-right: 40px;
}
.padrt-45 {
  padding-right: 45px;
}
.padrt-50 {
  padding-right: 50px;
}
.padrt-55 {
  padding-right: 55px;
}
.padrt-60 {
  padding-right: 60px;
}
.padrt-65 {
  padding-right: 65px;
}
.padrt-70 {
  padding-right: 70px;
}
.padrt-75 {
  padding-right: 75px;
}
.padrt-80 {
  padding-right: 80px;
}
.padrt-85 {
  padding-right: 85px;
}
.padrt-90 {
  padding-right: 90px;
}
.padrt-95 {
  padding-right: 95px;
}
.padrt-100 {
  padding-right: 100px;
}
.padrt-105 {
  padding-right: 105px;
}
.padrt-110 {
  padding-right: 110px;
}
.padrt-115 {
  padding-right: 115px;
}
.padrt-120 {
  padding-right: 120px;
}
.padrt-125 {
  padding-right: 125px;
}
.padrt-130 {
  padding-right: 130px;
}
.padrt-135 {
  padding-right: 135px;
}
.padrt-140 {
  padding-right: 140px;
}
.padrt-145 {
  padding-right: 145px;
}
.padrt-150 {
  padding-right: 150px;
}
.padrt-155 {
  padding-right: 155px;
}
.padrt-160 {
  padding-right: 160px;
}
.padrt-165 {
  padding-right: 165px;
}
.padrt-170 {
  padding-right: 170px;
}
.padrt-175 {
  padding-right: 175px;
}
.padrt-180 {
  padding-right: 180px;
}
.padrt-185 {
  padding-right: 185px;
}
.padrt-190 {
  padding-right: 190px;
}
.padrt-195 {
  padding-right: 195px;
}
.padrt-200 {
  padding-right: 200px;
}

.padleft-0 {
  padding-left: 0px;
}
.padleft-5 {
  padding-left: 5px;
}
.padleft-10 {
  padding-left: 10px;
}
.padleft-15 {
  padding-left: 15px;
}
.padleft-20 {
  padding-left: 20px;
}
.padleft-25 {
  padding-left: 25px;
}
.padleft-30 {
  padding-left: 30px;
}
.padleft-35 {
  padding-left: 35px;
}
.padleft-40 {
  padding-left: 40px;
}
.padleft-45 {
  padding-left: 45px;
}
.padleft-50 {
  padding-left: 50px;
}
.padleft-55 {
  padding-left: 55px;
}
.padleft-60 {
  padding-left: 60px;
}
.padleft-65 {
  padding-left: 65px;
}
.padleft-70 {
  padding-left: 70px;
}
.padleft-75 {
  padding-left: 75px;
}
.padleft-80 {
  padding-left: 80px;
}
.padleft-85 {
  padding-left: 85px;
}
.padleft-90 {
  padding-left: 90px;
}
.padleft-95 {
  padding-left: 95px;
}
.padleft-100 {
  padding-left: 100px;
}
.padleft-105 {
  padding-left: 105px;
}
.padleft-110 {
  padding-left: 110px;
}
.padleft-115 {
  padding-left: 115px;
}
.padleft-120 {
  padding-left: 120px;
}
.padleft-125 {
  padding-left: 125px;
}
.padleft-130 {
  padding-left: 130px;
}
.padleft-135 {
  padding-left: 135px;
}
.padleft-140 {
  padding-left: 140px;
}
.padleft-145 {
  padding-left: 145px;
}
.padleft-150 {
  padding-left: 150px;
}
.padleft-155 {
  padding-left: 155px;
}
.padleft-160 {
  padding-left: 160px;
}
.padleft-165 {
  padding-left: 165px;
}
.padleft-170 {
  padding-left: 170px;
}
.padleft-175 {
  padding-left: 175px;
}
.padleft-180 {
  padding-left: 180px;
}
.padleft-185 {
  padding-left: 185px;
}
.padleft-190 {
  padding-left: 190px;
}
.padleft-195 {
  padding-left: 195px;
}
.padleft-200 {
  padding-left: 200px;
}

/****************** Fonts ******************/
.font-8 {
  font-size: 8px;
}
.font-9 {
  font-size: 9px;
}
.font-10 {
  font-size: 10px;
}
.font-11 {
  font-size: 11px;
}
.font-12 {
  font-size: 12px;
}
.font-13 {
  font-size: 13px;
}
.font-14 {
  font-size: 14px;
}
.font-15 {
  font-size: 15px;
}
.font-16 {
  font-size: 16px;
}
.font-17 {
  font-size: 17px;
}
.font-18 {
  font-size: 18px;
}
.font-19 {
  font-size: 19px;
}
.font-20 {
  font-size: 20px;
}
.font-21 {
  font-size: 21px;
}
.font-22 {
  font-size: 22px;
}
.font-23 {
  font-size: 23px;
}
.font-24 {
  font-size: 24px;
}
.font-25 {
  font-size: 25px;
}
.font-26 {
  font-size: 26px;
}
.font-27 {
  font-size: 27px;
}
.font-28 {
  font-size: 28px;
}
.font-29 {
  font-size: 29px;
}
.font-30 {
  font-size: 30px;
}
.font-35 {
  font-size: 35px;
}
.font-40 {
  font-size: 40px;
}
.font-45 {
  font-size: 45px;
}
.font-50 {
  font-size: 50px;
}
.font-55 {
  font-size: 55px;
}
.font-60 {
  font-size: 60px;
}
.font-65 {
  font-size: 65px;
}
.font-70 {
  font-size: 70px;
}

.theme-btn {
  background-color: var(--main-color);
  color: #fff;
}
.text-u {
  text-transform: uppercase;
}
.rounded-btn {
  border-radius: 50px;
}
.rotate90 {
  transform: rotate(90deg);
}
.rotate180 {
  transform: rotate(180deg);
}
.rotate270 {
  transform: rotate(270deg);
}
.rotate-m-90 {
  transform: rotate(-90deg);
}
.rotate-m-180 {
  transform: rotate(-180deg);
}
.rotate-m-270 {
  transform: rotate(-270deg);
}

.font-weight-400 {
  font-weight: 500 !important;
}
.font-weight-500 {
  font-weight: 500 !important;
}
.font-weight-600 {
  font-weight: 500 !important;
}

.pd-y-60 {
  padding: 60px 0px;
}
.width-60per {
  width: 60% !important;
  margin: auto;
}

.modal .modal-content {
  background: #ffffff;
  border-radius: 15px;
  box-shadow: 0px 0px 4px #757575;
  max-width: none;
}

.modal .modal-content p{
  font-family: var(--relo-font-family);
  font-weight: 500;
}

.modal span.close {
  position: absolute;
  top: 10px;
  right: 15px;
  font-weight: 300;
  font-size: 28px;
line-height: 20px;
  cursor: pointer;
  color: #000000;
  font-family: roboto;
  font-size: 32px !important;
  opacity: 1;
  z-index: 99;
}

.modal .modal-content h6,
.ant-modal .ant-modal-body h6 {
  color: #000000;
  text-align: center;
  font-size: 20px;
  position: relative;
  margin-bottom: 25px;
  font-family: "Cabinet Grotesk", sans-serif;
  /* font-weight: 700; */
}



.modal .modal-content label {
  font-size: 16px;
  color: #000;
  font-weight: 500;
  font-family: "Cabinet Grotesk", sans-serif;
}
.modal .modal-content label b {
  font-family: "Cabinet Grotesk", sans-serif;
}
.modal .modal-content .form-control {
  font-size: 15px;
  padding: 10px 10px;
  min-width: initial;
  box-sizing: border-box;
  -webkit-transition: all 0.3s linear;
  transition: all 0.3s linear;
  color: #000;
  font-weight: 400;
  width: 100%;
  border: solid 1px rgba(0, 0, 0, 0.2);
  height: 43px;
  outline: 0px;
  box-shadow: none !important;
  border-radius: 6px;
  margin-bottom: 15px;
  font-family: "Cabinet Grotesk", sans-serif;
}

.modal-content .form-control.ant-form-control,
.modal-content .form-control.ant-select  {
  padding: 0;
}

.modal-content .form-control.ant-select.ant-select-multiple{
   height: auto;
   min-height: 43px;
}

.modal-content .form-control .ant-select ,
.modal-content .ant-select{
  height: 100%;
}
.modal-content .ant-form-control .ant-select,
.modal-content .ant-select-selection-search {
  height: 100%;
  background: #ffffff;
  width: 100%;
  inset: 0 !important;
  border-radius: 8px;
}
select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-color: #fff;
  background-repeat: no-repeat;
  background-position: 95% 50%;
}
.modal .modal-content select {
  font-size: 15px;
  padding: 10px 10px;
  min-width: initial;
  box-sizing: border-box;
  -webkit-transition: all 0.3s linear;
  transition: all 0.3s linear;
  color: #000;
  font-weight: 400;
  width: 100%;
  border: solid 1px rgba(0, 0, 0, 0.2);
  height: 43px;
  outline: 0px;
  box-shadow: none !important;
  border-radius: 6px;
  margin-bottom: 15px;
  font-family: "Cabinet Grotesk", sans-serif;
}
span.ant-select-selection-item {
  font-family: "Cabinet Grotesk", sans-serif;
  font-size: 16px;
}

.modal .modal-content .btn.theme-btn {
  background: #d7c7fa;
  color: #000000;
  border-radius: 6px;
  font-size: 15px;
  font-weight: 600;
  margin: auto;
  border: 2px solid #d7c7fa;
  padding: 6px 20px;
  font-family: "Cabinet Grotesk", sans-serif;
}
.modal .modal-content .btn.theme-btn:hover {
  background: #000000;
  color: #ffffff;
}
.modal .modal-content .btn.theme-btn.btn-dark{
  background: #000000;
  color: #ffffff;
}
.modal .modal-content .btn.theme-btn.btn-dark:hover{
  background: #ffffff;
  color: #000000;
}

.modal .modal-content select.form-control.is-invalid,
.modal .modal-content .form-control.is-invalid,
.modal .modal-content .ant-validation.is-invalid .form-control{
  border-color: #dc3545;
  padding-right: calc(1.5em + .75rem) !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-position: center right calc(.375em + .1875rem);
  background-size: calc(.75em + .375rem) calc(.75em + .375rem);
  
}





.fileupload {
  padding: 8px 10px 10px 10px !important;
}

.phone-flag .iti__selected-flag{
   background-color: #ffffff !important;
   border-radius: 10px
}
.text-right{
  text-align: right;
}
.checbox-label input[type='checkbox']{
  width: 20px;
  height: 20px;
}
.checbox-label {
  margin-top: 30px;
}

.checbox-label label.label_cls {
  margin-bottom: 0px;
  padding-left: 3px;
  top: 1px;
}`, "",{"version":3,"sources":["webpack://./public/assets/css/common.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB,iBAAiB;;AAEjB;EACE,qBAAqB;EACrB,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;;AAEA,2CAA2C;AAC3C;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA,4CAA4C;AAC5C;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB,iBAAiB;EACf,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,0BAA0B;EAC1B,UAAU;EACV,WAAW;AACb;;AAEA;;EAEE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,sBAAsB;AACxB;;;;AAIA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,0CAA0C;AAC5C;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,mCAAmC;EACnC,2BAA2B;EAC3B,WAAW;EACX,gBAAgB;EAChB,WAAW;EACX,oCAAoC;EACpC,YAAY;EACZ,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;;EAEE,UAAU;AACZ;;AAEA;GACG,YAAY;GACZ,gBAAgB;AACnB;;AAEA;;EAEE,YAAY;AACd;AACA;;EAEE,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;EAChB,mDAA2c;EAC3c,sBAAsB;EACtB,4BAA4B;EAC5B,4BAA4B;AAC9B;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,mCAAmC;EACnC,2BAA2B;EAC3B,WAAW;EACX,gBAAgB;EAChB,WAAW;EACX,oCAAoC;EACpC,YAAY;EACZ,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;AAC5C;AACA;EACE,0CAA0C;EAC1C,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,0CAA0C;AAC5C;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;EAGE,qBAAqB;EACrB,8CAA8C;EAC9C,yDAAsS;EACtS,4BAA4B;EAC5B,yDAAyD;EACzD,4DAA4D;;AAE9D;;;;;;AAMA;EACE,sCAAsC;AACxC;;AAEA;GACG,oCAAoC;GACpC;AACH;AACA;EACE,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,QAAQ;AACV","sourcesContent":["@charset \"utf-8\";\r\n/* CSS Document */\r\n\r\n:root {\r\n  --main-color: #e1251b;\r\n  --black: #000;\r\n  --dark: #071822;\r\n  --grey-regular: #f0f1f7;\r\n  --white-color: #fff;\r\n  --textclr1: #071822;\r\n}\r\n\r\n.mclr {\r\n  color: var(--main-color);\r\n}\r\n.wclr {\r\n  color: var(--white-color);\r\n}\r\n\r\n.width100per {\r\n  width: 100%;\r\n}\r\n.height100per {\r\n  height: 100%;\r\n}\r\n.width90per {\r\n  width: 90%;\r\n}\r\n.width80per {\r\n  width: 80%;\r\n}\r\n.width70per {\r\n  width: 70%;\r\n}\r\n.width60per {\r\n  width: 60%;\r\n}\r\n.width50per {\r\n  width: 50%;\r\n}\r\n.width40per {\r\n  width: 40%;\r\n}\r\n.width30per {\r\n  width: 30%;\r\n}\r\n.width20per {\r\n  width: 30%;\r\n}\r\n.width10per {\r\n  width: 10%;\r\n}\r\n\r\n.border-radius20 {\r\n  border-radius: 20px;\r\n}\r\n\r\n.cursor-pointer {\r\n  cursor: pointer;\r\n}\r\n.mrgtop-0 {\r\n  margin-top: 0px;\r\n}\r\n.mrgtop-5 {\r\n  margin-top: 5px;\r\n}\r\n.mrgtop-10 {\r\n  margin-top: 10px;\r\n}\r\n.mrgtop-15 {\r\n  margin-top: 15px;\r\n}\r\n.mrgtop-20 {\r\n  margin-top: 20px;\r\n}\r\n.mrgtop-25 {\r\n  margin-top: 25px;\r\n}\r\n.mrgtop-30 {\r\n  margin-top: 30px;\r\n}\r\n.mrgtop-35 {\r\n  margin-top: 35px;\r\n}\r\n.mrgtop-40 {\r\n  margin-top: 40px;\r\n}\r\n.mrgtop-45 {\r\n  margin-top: 45px;\r\n}\r\n.mrgtop-50 {\r\n  margin-top: 50px;\r\n}\r\n.mrgtop-55 {\r\n  margin-top: 55px;\r\n}\r\n.mrgtop-60 {\r\n  margin-top: 60px;\r\n}\r\n.mrgtop-65 {\r\n  margin-top: 65px;\r\n}\r\n.mrgtop-70 {\r\n  margin-top: 70px;\r\n}\r\n.mrgtop-75 {\r\n  margin-top: 75px;\r\n}\r\n.mrgtop-80 {\r\n  margin-top: 80px;\r\n}\r\n.mrgtop-85 {\r\n  margin-top: 85px;\r\n}\r\n.mrgtop-90 {\r\n  margin-top: 90px;\r\n}\r\n.mrgtop-95 {\r\n  margin-top: 95px;\r\n}\r\n.mrgtop-100 {\r\n  margin-top: 100px;\r\n}\r\n.mrgtop-105 {\r\n  margin-top: 105px;\r\n}\r\n.mrgtop-110 {\r\n  margin-top: 110px;\r\n}\r\n.mrgtop-115 {\r\n  margin-top: 115px;\r\n}\r\n.mrgtop-120 {\r\n  margin-top: 120px;\r\n}\r\n.mrgtop-125 {\r\n  margin-top: 125px;\r\n}\r\n.mrgtop-130 {\r\n  margin-top: 130px;\r\n}\r\n.mrgtop-135 {\r\n  margin-top: 135px;\r\n}\r\n.mrgtop-140 {\r\n  margin-top: 140px;\r\n}\r\n.mrgtop-145 {\r\n  margin-top: 145px;\r\n}\r\n.mrgtop-150 {\r\n  margin-top: 150px;\r\n}\r\n.mrgtop-155 {\r\n  margin-top: 155px;\r\n}\r\n.mrgtop-160 {\r\n  margin-top: 160px;\r\n}\r\n.mrgtop-165 {\r\n  margin-top: 165px;\r\n}\r\n.mrgtop-170 {\r\n  margin-top: 170px;\r\n}\r\n.mrgtop-175 {\r\n  margin-top: 175px;\r\n}\r\n.mrgtop-180 {\r\n  margin-top: 180px;\r\n}\r\n.mrgtop-185 {\r\n  margin-top: 185px;\r\n}\r\n.mrgtop-190 {\r\n  margin-top: 190px;\r\n}\r\n.mrgtop-195 {\r\n  margin-top: 195px;\r\n}\r\n.mrgtop-200 {\r\n  margin-top: 200px;\r\n}\r\n\r\n.mrgbtm-0 {\r\n  margin-bottom: 0px;\r\n}\r\n.mrgbtm-5 {\r\n  margin-bottom: 5px;\r\n}\r\n.mrgbtm-10 {\r\n  margin-bottom: 10px;\r\n}\r\n.mrgbtm-15 {\r\n  margin-bottom: 15px;\r\n}\r\n.mrgbtm-20 {\r\n  margin-bottom: 20px;\r\n}\r\n.mrgbtm-25 {\r\n  margin-bottom: 25px;\r\n}\r\n.mrgbtm-30 {\r\n  margin-bottom: 30px;\r\n}\r\n.mrgbtm-35 {\r\n  margin-bottom: 35px;\r\n}\r\n.mrgbtm-40 {\r\n  margin-bottom: 40px;\r\n}\r\n.mrgbtm-45 {\r\n  margin-bottom: 45px;\r\n}\r\n.mrgbtm-50 {\r\n  margin-bottom: 50px;\r\n}\r\n.mrgbtm-55 {\r\n  margin-bottom: 55px;\r\n}\r\n.mrgbtm-60 {\r\n  margin-bottom: 60px;\r\n}\r\n.mrgbtm-65 {\r\n  margin-bottom: 65px;\r\n}\r\n.mrgbtm-70 {\r\n  margin-bottom: 70px;\r\n}\r\n.mrgbtm-75 {\r\n  margin-bottom: 75px;\r\n}\r\n.mrgbtm-80 {\r\n  margin-bottom: 80px;\r\n}\r\n.mrgbtm-85 {\r\n  margin-bottom: 85px;\r\n}\r\n.mrgbtm-90 {\r\n  margin-bottom: 90px;\r\n}\r\n.mrgbtm-95 {\r\n  margin-bottom: 95px;\r\n}\r\n.mrgbtm-100 {\r\n  margin-bottom: 100px;\r\n}\r\n.mrgbtm-105 {\r\n  margin-bottom: 105px;\r\n}\r\n.mrgbtm-110 {\r\n  margin-bottom: 110px;\r\n}\r\n.mrgbtm-115 {\r\n  margin-bottom: 115px;\r\n}\r\n.mrgbtm-120 {\r\n  margin-bottom: 120px;\r\n}\r\n.mrgbtm-125 {\r\n  margin-bottom: 125px;\r\n}\r\n.mrgbtm-130 {\r\n  margin-bottom: 130px;\r\n}\r\n.mrgbtm-135 {\r\n  margin-bottom: 135px;\r\n}\r\n.mrgbtm-140 {\r\n  margin-bottom: 140px;\r\n}\r\n.mrgbtm-145 {\r\n  margin-bottom: 145px;\r\n}\r\n.mrgbtm-150 {\r\n  margin-bottom: 150px;\r\n}\r\n.mrgbtm-155 {\r\n  margin-bottom: 155px;\r\n}\r\n.mrgbtm-160 {\r\n  margin-bottom: 160px;\r\n}\r\n.mrgbtm-165 {\r\n  margin-bottom: 165px;\r\n}\r\n.mrgbtm-170 {\r\n  margin-bottom: 170px;\r\n}\r\n.mrgbtm-175 {\r\n  margin-bottom: 175px;\r\n}\r\n.mrgbtm-180 {\r\n  margin-bottom: 180px;\r\n}\r\n.mrgbtm-185 {\r\n  margin-bottom: 185px;\r\n}\r\n.mrgbtm-190 {\r\n  margin-bottom: 190px;\r\n}\r\n.mrgbtm-195 {\r\n  margin-bottom: 195px;\r\n}\r\n.mrgbtm-200 {\r\n  margin-bottom: 200px;\r\n}\r\n\r\n.mrgrt-0 {\r\n  margin-right: 0px;\r\n}\r\n.mrgrt-5 {\r\n  margin-right: 5px;\r\n}\r\n.mrgrt-10 {\r\n  margin-right: 10px;\r\n}\r\n.mrgrt-15 {\r\n  margin-right: 15px;\r\n}\r\n.mrgrt-20 {\r\n  margin-right: 20px;\r\n}\r\n.mrgrt-25 {\r\n  margin-right: 25px;\r\n}\r\n.mrgrt-30 {\r\n  margin-right: 30px;\r\n}\r\n.mrgrt-35 {\r\n  margin-right: 35px;\r\n}\r\n.mrgrt-40 {\r\n  margin-right: 40px;\r\n}\r\n.mrgrt-45 {\r\n  margin-right: 45px;\r\n}\r\n.mrgrt-50 {\r\n  margin-right: 50px;\r\n}\r\n.mrgrt-55 {\r\n  margin-right: 55px;\r\n}\r\n.mrgrt-60 {\r\n  margin-right: 60px;\r\n}\r\n.mrgrt-65 {\r\n  margin-right: 65px;\r\n}\r\n.mrgrt-70 {\r\n  margin-right: 70px;\r\n}\r\n.mrgrt-75 {\r\n  margin-right: 75px;\r\n}\r\n.mrgrt-80 {\r\n  margin-right: 80px;\r\n}\r\n.mrgrt-85 {\r\n  margin-right: 85px;\r\n}\r\n.mrgrt-90 {\r\n  margin-right: 90px;\r\n}\r\n.mrgrt-95 {\r\n  margin-right: 95px;\r\n}\r\n.mrgrt-100 {\r\n  margin-right: 100px;\r\n}\r\n.mrgrt-105 {\r\n  margin-right: 105px;\r\n}\r\n.mrgrt-110 {\r\n  margin-right: 110px;\r\n}\r\n.mrgrt-115 {\r\n  margin-right: 115px;\r\n}\r\n.mrgrt-120 {\r\n  margin-right: 120px;\r\n}\r\n.mrgrt-125 {\r\n  margin-right: 125px;\r\n}\r\n.mrgrt-130 {\r\n  margin-right: 130px;\r\n}\r\n.mrgrt-135 {\r\n  margin-right: 135px;\r\n}\r\n.mrgrt-140 {\r\n  margin-right: 140px;\r\n}\r\n.mrgrt-145 {\r\n  margin-right: 145px;\r\n}\r\n.mrgrt-150 {\r\n  margin-right: 150px;\r\n}\r\n.mrgrt-155 {\r\n  margin-right: 155px;\r\n}\r\n.mrgrt-160 {\r\n  margin-right: 160px;\r\n}\r\n.mrgrt-165 {\r\n  margin-right: 165px;\r\n}\r\n.mrgrt-170 {\r\n  margin-right: 170px;\r\n}\r\n.mrgrt-175 {\r\n  margin-right: 175px;\r\n}\r\n.mrgrt-180 {\r\n  margin-right: 180px;\r\n}\r\n.mrgrt-185 {\r\n  margin-right: 185px;\r\n}\r\n.mrgrt-190 {\r\n  margin-right: 190px;\r\n}\r\n.mrgrt-195 {\r\n  margin-right: 195px;\r\n}\r\n.mrgrt-200 {\r\n  margin-right: 200px;\r\n}\r\n\r\n.mrgleft-0 {\r\n  margin-left: 0px;\r\n}\r\n.mrgleft-5 {\r\n  margin-left: 5px;\r\n}\r\n.mrgleft-10 {\r\n  margin-left: 10px;\r\n}\r\n.mrgleft-15 {\r\n  margin-left: 15px;\r\n}\r\n.mrgleft-20 {\r\n  margin-left: 20px;\r\n}\r\n.mrgleft-25 {\r\n  margin-left: 25px;\r\n}\r\n.mrgleft-30 {\r\n  margin-left: 30px;\r\n}\r\n.mrgleft-35 {\r\n  margin-left: 35px;\r\n}\r\n.mrgleft-40 {\r\n  margin-left: 40px;\r\n}\r\n.mrgleft-45 {\r\n  margin-left: 45px;\r\n}\r\n.mrgleft-50 {\r\n  margin-left: 50px;\r\n}\r\n.mrgleft-55 {\r\n  margin-left: 55px;\r\n}\r\n.mrgleft-60 {\r\n  margin-left: 60px;\r\n}\r\n.mrgleft-65 {\r\n  margin-left: 65px;\r\n}\r\n.mrgleft-70 {\r\n  margin-left: 70px;\r\n}\r\n.mrgleft-75 {\r\n  margin-left: 75px;\r\n}\r\n.mrgleft-80 {\r\n  margin-left: 80px;\r\n}\r\n.mrgleft-85 {\r\n  margin-left: 85px;\r\n}\r\n.mrgleft-90 {\r\n  margin-left: 90px;\r\n}\r\n.mrgleft-95 {\r\n  margin-left: 95px;\r\n}\r\n.mrgleft-100 {\r\n  margin-left: 100px;\r\n}\r\n.mrgleft-105 {\r\n  margin-left: 105px;\r\n}\r\n.mrgleft-110 {\r\n  margin-left: 110px;\r\n}\r\n.mrgleft-115 {\r\n  margin-left: 115px;\r\n}\r\n.mrgleft-120 {\r\n  margin-left: 120px;\r\n}\r\n.mrgleft-125 {\r\n  margin-left: 125px;\r\n}\r\n.mrgleft-130 {\r\n  margin-left: 130px;\r\n}\r\n.mrgleft-135 {\r\n  margin-left: 135px;\r\n}\r\n.mrgleft-140 {\r\n  margin-left: 140px;\r\n}\r\n.mrgleft-145 {\r\n  margin-left: 145px;\r\n}\r\n.mrgleft-150 {\r\n  margin-left: 150px;\r\n}\r\n.mrgleft-155 {\r\n  margin-left: 155px;\r\n}\r\n.mrgleft-160 {\r\n  margin-left: 160px;\r\n}\r\n.mrgleft-165 {\r\n  margin-left: 165px;\r\n}\r\n.mrgleft-170 {\r\n  margin-left: 170px;\r\n}\r\n.mrgleft-175 {\r\n  margin-left: 175px;\r\n}\r\n.mrgleft-180 {\r\n  margin-left: 180px;\r\n}\r\n.mrgleft-185 {\r\n  margin-left: 185px;\r\n}\r\n.mrgleft-190 {\r\n  margin-left: 190px;\r\n}\r\n.mrgleft-195 {\r\n  margin-left: 195px;\r\n}\r\n.mrgleft-200 {\r\n  margin-left: 200px;\r\n}\r\n\r\n/************** paddings ******************/\r\n.padtop-0 {\r\n  padding-top: 0px;\r\n}\r\n.padtop-5 {\r\n  padding-top: 5px;\r\n}\r\n.padtop-10 {\r\n  padding-top: 10px;\r\n}\r\n.padtop-15 {\r\n  padding-top: 15px;\r\n}\r\n.padtop-20 {\r\n  padding-top: 20px;\r\n}\r\n.padtop-25 {\r\n  padding-top: 25px;\r\n}\r\n.padtop-30 {\r\n  padding-top: 30px;\r\n}\r\n.padtop-35 {\r\n  padding-top: 35px;\r\n}\r\n.padtop-40 {\r\n  padding-top: 40px;\r\n}\r\n.padtop-45 {\r\n  padding-top: 45px;\r\n}\r\n.padtop-50 {\r\n  padding-top: 50px;\r\n}\r\n.padtop-55 {\r\n  padding-top: 55px;\r\n}\r\n.padtop-60 {\r\n  padding-top: 60px;\r\n}\r\n.padtop-65 {\r\n  padding-top: 65px;\r\n}\r\n.padtop-70 {\r\n  padding-top: 70px;\r\n}\r\n.padtop-75 {\r\n  padding-top: 75px;\r\n}\r\n.padtop-80 {\r\n  padding-top: 80px;\r\n}\r\n.padtop-85 {\r\n  padding-top: 85px;\r\n}\r\n.padtop-90 {\r\n  padding-top: 90px;\r\n}\r\n.padtop-95 {\r\n  padding-top: 95px;\r\n}\r\n.padtop-100 {\r\n  padding-top: 100px;\r\n}\r\n.padtop-105 {\r\n  padding-top: 105px;\r\n}\r\n.padtop-110 {\r\n  padding-top: 110px;\r\n}\r\n.padtop-115 {\r\n  padding-top: 115px;\r\n}\r\n.padtop-120 {\r\n  padding-top: 120px;\r\n}\r\n.padtop-125 {\r\n  padding-top: 125px;\r\n}\r\n.padtop-130 {\r\n  padding-top: 130px;\r\n}\r\n.padtop-135 {\r\n  padding-top: 135px;\r\n}\r\n.padtop-140 {\r\n  padding-top: 140px;\r\n}\r\n.padtop-145 {\r\n  padding-top: 145px;\r\n}\r\n.padtop-150 {\r\n  padding-top: 150px;\r\n}\r\n.padtop-155 {\r\n  padding-top: 155px;\r\n}\r\n.padtop-160 {\r\n  padding-top: 160px;\r\n}\r\n.padtop-165 {\r\n  padding-top: 165px;\r\n}\r\n.padtop-170 {\r\n  padding-top: 170px;\r\n}\r\n.padtop-175 {\r\n  padding-top: 175px;\r\n}\r\n.padtop-180 {\r\n  padding-top: 180px;\r\n}\r\n.padtop-185 {\r\n  padding-top: 185px;\r\n}\r\n.padtop-190 {\r\n  padding-top: 190px;\r\n}\r\n.padtop-195 {\r\n  padding-top: 195px;\r\n}\r\n.padtop-200 {\r\n  padding-top: 200px;\r\n}\r\n\r\n.padbtm-0 {\r\n  padding-bottom: 0px;\r\n}\r\n.padbtm-5 {\r\n  padding-bottom: 5px;\r\n}\r\n.padbtm-10 {\r\n  padding-bottom: 10px;\r\n}\r\n.padbtm-15 {\r\n  padding-bottom: 15px;\r\n}\r\n.padbtm-20 {\r\n  padding-bottom: 20px;\r\n}\r\n.padbtm-25 {\r\n  padding-bottom: 25px;\r\n}\r\n.padbtm-30 {\r\n  padding-bottom: 30px;\r\n}\r\n.padbtm-35 {\r\n  padding-bottom: 35px;\r\n}\r\n.padbtm-40 {\r\n  padding-bottom: 40px;\r\n}\r\n.padbtm-45 {\r\n  padding-bottom: 45px;\r\n}\r\n.padbtm-50 {\r\n  padding-bottom: 50px;\r\n}\r\n.padbtm-55 {\r\n  padding-bottom: 55px;\r\n}\r\n.padbtm-60 {\r\n  padding-bottom: 60px;\r\n}\r\n.padbtm-65 {\r\n  padding-bottom: 65px;\r\n}\r\n.padbtm-70 {\r\n  padding-bottom: 70px;\r\n}\r\n.padbtm-75 {\r\n  padding-bottom: 75px;\r\n}\r\n.padbtm-80 {\r\n  padding-bottom: 80px;\r\n}\r\n.padbtm-85 {\r\n  padding-bottom: 85px;\r\n}\r\n.padbtm-90 {\r\n  padding-bottom: 90px;\r\n}\r\n.padbtm-95 {\r\n  padding-bottom: 95px;\r\n}\r\n.padbtm-100 {\r\n  padding-bottom: 100px;\r\n}\r\n.padbtm-105 {\r\n  padding-bottom: 105px;\r\n}\r\n.padbtm-110 {\r\n  padding-bottom: 110px;\r\n}\r\n.padbtm-115 {\r\n  padding-bottom: 115px;\r\n}\r\n.padbtm-120 {\r\n  padding-bottom: 120px;\r\n}\r\n.padbtm-125 {\r\n  padding-bottom: 125px;\r\n}\r\n.padbtm-130 {\r\n  padding-bottom: 130px;\r\n}\r\n.padbtm-135 {\r\n  padding-bottom: 135px;\r\n}\r\n.padbtm-140 {\r\n  padding-bottom: 140px;\r\n}\r\n.padbtm-145 {\r\n  padding-bottom: 145px;\r\n}\r\n.padbtm-150 {\r\n  padding-bottom: 150px;\r\n}\r\n.padbtm-155 {\r\n  padding-bottom: 155px;\r\n}\r\n.padbtm-160 {\r\n  padding-bottom: 160px;\r\n}\r\n.padbtm-165 {\r\n  padding-bottom: 165px;\r\n}\r\n.padbtm-170 {\r\n  padding-bottom: 170px;\r\n}\r\n.padbtm-175 {\r\n  padding-bottom: 175px;\r\n}\r\n.padbtm-180 {\r\n  padding-bottom: 180px;\r\n}\r\n.padbtm-185 {\r\n  padding-bottom: 185px;\r\n}\r\n.padbtm-190 {\r\n  padding-bottom: 190px;\r\n}\r\n.padbtm-195 {\r\n  padding-bottom: 195px;\r\n}\r\n.padbtm-200 {\r\n  padding-bottom: 200px;\r\n}\r\n\r\n.padrt-0 {\r\n  padding-right: 0px;\r\n}\r\n.padrt-5 {\r\n  padding-right: 5px;\r\n}\r\n.padrt-10 {\r\n  padding-right: 10px;\r\n}\r\n.padrt-15 {\r\n  padding-right: 15px;\r\n}\r\n.padrt-20 {\r\n  padding-right: 20px;\r\n}\r\n.padrt-25 {\r\n  padding-right: 25px;\r\n}\r\n.padrt-30 {\r\n  padding-right: 30px;\r\n}\r\n.padrt-35 {\r\n  padding-right: 35px;\r\n}\r\n.padrt-40 {\r\n  padding-right: 40px;\r\n}\r\n.padrt-45 {\r\n  padding-right: 45px;\r\n}\r\n.padrt-50 {\r\n  padding-right: 50px;\r\n}\r\n.padrt-55 {\r\n  padding-right: 55px;\r\n}\r\n.padrt-60 {\r\n  padding-right: 60px;\r\n}\r\n.padrt-65 {\r\n  padding-right: 65px;\r\n}\r\n.padrt-70 {\r\n  padding-right: 70px;\r\n}\r\n.padrt-75 {\r\n  padding-right: 75px;\r\n}\r\n.padrt-80 {\r\n  padding-right: 80px;\r\n}\r\n.padrt-85 {\r\n  padding-right: 85px;\r\n}\r\n.padrt-90 {\r\n  padding-right: 90px;\r\n}\r\n.padrt-95 {\r\n  padding-right: 95px;\r\n}\r\n.padrt-100 {\r\n  padding-right: 100px;\r\n}\r\n.padrt-105 {\r\n  padding-right: 105px;\r\n}\r\n.padrt-110 {\r\n  padding-right: 110px;\r\n}\r\n.padrt-115 {\r\n  padding-right: 115px;\r\n}\r\n.padrt-120 {\r\n  padding-right: 120px;\r\n}\r\n.padrt-125 {\r\n  padding-right: 125px;\r\n}\r\n.padrt-130 {\r\n  padding-right: 130px;\r\n}\r\n.padrt-135 {\r\n  padding-right: 135px;\r\n}\r\n.padrt-140 {\r\n  padding-right: 140px;\r\n}\r\n.padrt-145 {\r\n  padding-right: 145px;\r\n}\r\n.padrt-150 {\r\n  padding-right: 150px;\r\n}\r\n.padrt-155 {\r\n  padding-right: 155px;\r\n}\r\n.padrt-160 {\r\n  padding-right: 160px;\r\n}\r\n.padrt-165 {\r\n  padding-right: 165px;\r\n}\r\n.padrt-170 {\r\n  padding-right: 170px;\r\n}\r\n.padrt-175 {\r\n  padding-right: 175px;\r\n}\r\n.padrt-180 {\r\n  padding-right: 180px;\r\n}\r\n.padrt-185 {\r\n  padding-right: 185px;\r\n}\r\n.padrt-190 {\r\n  padding-right: 190px;\r\n}\r\n.padrt-195 {\r\n  padding-right: 195px;\r\n}\r\n.padrt-200 {\r\n  padding-right: 200px;\r\n}\r\n\r\n.padleft-0 {\r\n  padding-left: 0px;\r\n}\r\n.padleft-5 {\r\n  padding-left: 5px;\r\n}\r\n.padleft-10 {\r\n  padding-left: 10px;\r\n}\r\n.padleft-15 {\r\n  padding-left: 15px;\r\n}\r\n.padleft-20 {\r\n  padding-left: 20px;\r\n}\r\n.padleft-25 {\r\n  padding-left: 25px;\r\n}\r\n.padleft-30 {\r\n  padding-left: 30px;\r\n}\r\n.padleft-35 {\r\n  padding-left: 35px;\r\n}\r\n.padleft-40 {\r\n  padding-left: 40px;\r\n}\r\n.padleft-45 {\r\n  padding-left: 45px;\r\n}\r\n.padleft-50 {\r\n  padding-left: 50px;\r\n}\r\n.padleft-55 {\r\n  padding-left: 55px;\r\n}\r\n.padleft-60 {\r\n  padding-left: 60px;\r\n}\r\n.padleft-65 {\r\n  padding-left: 65px;\r\n}\r\n.padleft-70 {\r\n  padding-left: 70px;\r\n}\r\n.padleft-75 {\r\n  padding-left: 75px;\r\n}\r\n.padleft-80 {\r\n  padding-left: 80px;\r\n}\r\n.padleft-85 {\r\n  padding-left: 85px;\r\n}\r\n.padleft-90 {\r\n  padding-left: 90px;\r\n}\r\n.padleft-95 {\r\n  padding-left: 95px;\r\n}\r\n.padleft-100 {\r\n  padding-left: 100px;\r\n}\r\n.padleft-105 {\r\n  padding-left: 105px;\r\n}\r\n.padleft-110 {\r\n  padding-left: 110px;\r\n}\r\n.padleft-115 {\r\n  padding-left: 115px;\r\n}\r\n.padleft-120 {\r\n  padding-left: 120px;\r\n}\r\n.padleft-125 {\r\n  padding-left: 125px;\r\n}\r\n.padleft-130 {\r\n  padding-left: 130px;\r\n}\r\n.padleft-135 {\r\n  padding-left: 135px;\r\n}\r\n.padleft-140 {\r\n  padding-left: 140px;\r\n}\r\n.padleft-145 {\r\n  padding-left: 145px;\r\n}\r\n.padleft-150 {\r\n  padding-left: 150px;\r\n}\r\n.padleft-155 {\r\n  padding-left: 155px;\r\n}\r\n.padleft-160 {\r\n  padding-left: 160px;\r\n}\r\n.padleft-165 {\r\n  padding-left: 165px;\r\n}\r\n.padleft-170 {\r\n  padding-left: 170px;\r\n}\r\n.padleft-175 {\r\n  padding-left: 175px;\r\n}\r\n.padleft-180 {\r\n  padding-left: 180px;\r\n}\r\n.padleft-185 {\r\n  padding-left: 185px;\r\n}\r\n.padleft-190 {\r\n  padding-left: 190px;\r\n}\r\n.padleft-195 {\r\n  padding-left: 195px;\r\n}\r\n.padleft-200 {\r\n  padding-left: 200px;\r\n}\r\n\r\n/****************** Fonts ******************/\r\n.font-8 {\r\n  font-size: 8px;\r\n}\r\n.font-9 {\r\n  font-size: 9px;\r\n}\r\n.font-10 {\r\n  font-size: 10px;\r\n}\r\n.font-11 {\r\n  font-size: 11px;\r\n}\r\n.font-12 {\r\n  font-size: 12px;\r\n}\r\n.font-13 {\r\n  font-size: 13px;\r\n}\r\n.font-14 {\r\n  font-size: 14px;\r\n}\r\n.font-15 {\r\n  font-size: 15px;\r\n}\r\n.font-16 {\r\n  font-size: 16px;\r\n}\r\n.font-17 {\r\n  font-size: 17px;\r\n}\r\n.font-18 {\r\n  font-size: 18px;\r\n}\r\n.font-19 {\r\n  font-size: 19px;\r\n}\r\n.font-20 {\r\n  font-size: 20px;\r\n}\r\n.font-21 {\r\n  font-size: 21px;\r\n}\r\n.font-22 {\r\n  font-size: 22px;\r\n}\r\n.font-23 {\r\n  font-size: 23px;\r\n}\r\n.font-24 {\r\n  font-size: 24px;\r\n}\r\n.font-25 {\r\n  font-size: 25px;\r\n}\r\n.font-26 {\r\n  font-size: 26px;\r\n}\r\n.font-27 {\r\n  font-size: 27px;\r\n}\r\n.font-28 {\r\n  font-size: 28px;\r\n}\r\n.font-29 {\r\n  font-size: 29px;\r\n}\r\n.font-30 {\r\n  font-size: 30px;\r\n}\r\n.font-35 {\r\n  font-size: 35px;\r\n}\r\n.font-40 {\r\n  font-size: 40px;\r\n}\r\n.font-45 {\r\n  font-size: 45px;\r\n}\r\n.font-50 {\r\n  font-size: 50px;\r\n}\r\n.font-55 {\r\n  font-size: 55px;\r\n}\r\n.font-60 {\r\n  font-size: 60px;\r\n}\r\n.font-65 {\r\n  font-size: 65px;\r\n}\r\n.font-70 {\r\n  font-size: 70px;\r\n}\r\n\r\n.theme-btn {\r\n  background-color: var(--main-color);\r\n  color: #fff;\r\n}\r\n.text-u {\r\n  text-transform: uppercase;\r\n}\r\n.rounded-btn {\r\n  border-radius: 50px;\r\n}\r\n.rotate90 {\r\n  transform: rotate(90deg);\r\n}\r\n.rotate180 {\r\n  transform: rotate(180deg);\r\n}\r\n.rotate270 {\r\n  transform: rotate(270deg);\r\n}\r\n.rotate-m-90 {\r\n  transform: rotate(-90deg);\r\n}\r\n.rotate-m-180 {\r\n  transform: rotate(-180deg);\r\n}\r\n.rotate-m-270 {\r\n  transform: rotate(-270deg);\r\n}\r\n\r\n.font-weight-400 {\r\n  font-weight: 500 !important;\r\n}\r\n.font-weight-500 {\r\n  font-weight: 500 !important;\r\n}\r\n.font-weight-600 {\r\n  font-weight: 500 !important;\r\n}\r\n\r\n.pd-y-60 {\r\n  padding: 60px 0px;\r\n}\r\n.width-60per {\r\n  width: 60% !important;\r\n  margin: auto;\r\n}\r\n\r\n.modal .modal-content {\r\n  background: #ffffff;\r\n  border-radius: 15px;\r\n  box-shadow: 0px 0px 4px #757575;\r\n  max-width: none;\r\n}\r\n\r\n.modal .modal-content p{\r\n  font-family: var(--relo-font-family);\r\n  font-weight: 500;\r\n}\r\n\r\n.modal span.close {\r\n  position: absolute;\r\n  top: 10px;\r\n  right: 15px;\r\n  font-weight: 300;\r\n  font-size: 28px;\r\nline-height: 20px;\r\n  cursor: pointer;\r\n  color: #000000;\r\n  font-family: roboto;\r\n  font-size: 32px !important;\r\n  opacity: 1;\r\n  z-index: 99;\r\n}\r\n\r\n.modal .modal-content h6,\r\n.ant-modal .ant-modal-body h6 {\r\n  color: #000000;\r\n  text-align: center;\r\n  font-size: 20px;\r\n  position: relative;\r\n  margin-bottom: 25px;\r\n  font-family: \"Cabinet Grotesk\", sans-serif;\r\n  /* font-weight: 700; */\r\n}\r\n\r\n\r\n\r\n.modal .modal-content label {\r\n  font-size: 16px;\r\n  color: #000;\r\n  font-weight: 500;\r\n  font-family: \"Cabinet Grotesk\", sans-serif;\r\n}\r\n.modal .modal-content label b {\r\n  font-family: \"Cabinet Grotesk\", sans-serif;\r\n}\r\n.modal .modal-content .form-control {\r\n  font-size: 15px;\r\n  padding: 10px 10px;\r\n  min-width: initial;\r\n  box-sizing: border-box;\r\n  -webkit-transition: all 0.3s linear;\r\n  transition: all 0.3s linear;\r\n  color: #000;\r\n  font-weight: 400;\r\n  width: 100%;\r\n  border: solid 1px rgba(0, 0, 0, 0.2);\r\n  height: 43px;\r\n  outline: 0px;\r\n  box-shadow: none !important;\r\n  border-radius: 6px;\r\n  margin-bottom: 15px;\r\n  font-family: \"Cabinet Grotesk\", sans-serif;\r\n}\r\n\r\n.modal-content .form-control.ant-form-control,\r\n.modal-content .form-control.ant-select  {\r\n  padding: 0;\r\n}\r\n\r\n.modal-content .form-control.ant-select.ant-select-multiple{\r\n   height: auto;\r\n   min-height: 43px;\r\n}\r\n\r\n.modal-content .form-control .ant-select ,\r\n.modal-content .ant-select{\r\n  height: 100%;\r\n}\r\n.modal-content .ant-form-control .ant-select,\r\n.modal-content .ant-select-selection-search {\r\n  height: 100%;\r\n  background: #ffffff;\r\n  width: 100%;\r\n  inset: 0 !important;\r\n  border-radius: 8px;\r\n}\r\nselect {\r\n  -webkit-appearance: none;\r\n  -moz-appearance: none;\r\n  appearance: none;\r\n  background: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14.001' height='8.165' viewBox='0 0 14.001 8.165'%3E%3Cdefs%3E%3Cstyle%3E.a%7Bfill:%23212121;%7D%3C/style%3E%3C/defs%3E%3Cpath class='a' d='M13.861,60.224l-.7-.7a.441.441,0,0,0-.645,0L7,65.036,1.487,59.522a.441.441,0,0,0-.645,0l-.7.7a.441.441,0,0,0,0,.645l6.537,6.538a.441.441,0,0,0,.645,0l6.538-6.538a.442.442,0,0,0,0-.645Z' transform='translate(0 -59.382)'/%3E%3C/svg%3E\");\r\n  background-color: #fff;\r\n  background-repeat: no-repeat;\r\n  background-position: 95% 50%;\r\n}\r\n.modal .modal-content select {\r\n  font-size: 15px;\r\n  padding: 10px 10px;\r\n  min-width: initial;\r\n  box-sizing: border-box;\r\n  -webkit-transition: all 0.3s linear;\r\n  transition: all 0.3s linear;\r\n  color: #000;\r\n  font-weight: 400;\r\n  width: 100%;\r\n  border: solid 1px rgba(0, 0, 0, 0.2);\r\n  height: 43px;\r\n  outline: 0px;\r\n  box-shadow: none !important;\r\n  border-radius: 6px;\r\n  margin-bottom: 15px;\r\n  font-family: \"Cabinet Grotesk\", sans-serif;\r\n}\r\nspan.ant-select-selection-item {\r\n  font-family: \"Cabinet Grotesk\", sans-serif;\r\n  font-size: 16px;\r\n}\r\n\r\n.modal .modal-content .btn.theme-btn {\r\n  background: #d7c7fa;\r\n  color: #000000;\r\n  border-radius: 6px;\r\n  font-size: 15px;\r\n  font-weight: 600;\r\n  margin: auto;\r\n  border: 2px solid #d7c7fa;\r\n  padding: 6px 20px;\r\n  font-family: \"Cabinet Grotesk\", sans-serif;\r\n}\r\n.modal .modal-content .btn.theme-btn:hover {\r\n  background: #000000;\r\n  color: #ffffff;\r\n}\r\n.modal .modal-content .btn.theme-btn.btn-dark{\r\n  background: #000000;\r\n  color: #ffffff;\r\n}\r\n.modal .modal-content .btn.theme-btn.btn-dark:hover{\r\n  background: #ffffff;\r\n  color: #000000;\r\n}\r\n\r\n.modal .modal-content select.form-control.is-invalid,\r\n.modal .modal-content .form-control.is-invalid,\r\n.modal .modal-content .ant-validation.is-invalid .form-control{\r\n  border-color: #dc3545;\r\n  padding-right: calc(1.5em + .75rem) !important;\r\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23dc3545' viewBox='-2 -2 7 7'%3e%3cpath stroke='%23dc3545' d='M0 0l3 3m0-3L0 3'/%3e%3ccircle r='.5'/%3e%3ccircle cx='3' r='.5'/%3e%3ccircle cy='3' r='.5'/%3e%3ccircle cx='3' cy='3' r='.5'/%3e%3c/svg%3E\");\r\n  background-repeat: no-repeat;\r\n  background-position: center right calc(.375em + .1875rem);\r\n  background-size: calc(.75em + .375rem) calc(.75em + .375rem);\r\n  \r\n}\r\n\r\n\r\n\r\n\r\n\r\n.fileupload {\r\n  padding: 8px 10px 10px 10px !important;\r\n}\r\n\r\n.phone-flag .iti__selected-flag{\r\n   background-color: #ffffff !important;\r\n   border-radius: 10px\r\n}\r\n.text-right{\r\n  text-align: right;\r\n}\r\n.checbox-label input[type='checkbox']{\r\n  width: 20px;\r\n  height: 20px;\r\n}\r\n.checbox-label {\r\n  margin-top: 30px;\r\n}\r\n\r\n.checbox-label label.label_cls {\r\n  margin-bottom: 0px;\r\n  padding-left: 3px;\r\n  top: 1px;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
